import { List, ListSubheader, Stack, Typography } from '@mui/material';
import { Link as ReactRouterLink } from 'react-router-dom';
import { useAuthState } from 'state/useAuthState';
import UserStatusChip from 'components/Map/UserStatusChip';
import { Wildfire } from 'features/wildfires/wildfire.types';
import { useTranslation } from 'react-i18next';
import { CoordinatesListItem } from 'components/CoordinatesListItem';
import { LocationDescriptor } from 'history';
import { MEMBERSHIP_PLANS } from '../../../../constants';

type CoordinatesListProps = {
  wildfire: Wildfire;
};

type LinkButtonProps = {
  to: LocationDescriptor;
  component: typeof ReactRouterLink;
};

export const CoordinatesList = (props: CoordinatesListProps): JSX.Element => {
  const { wildfire } = props;
  const { t } = useTranslation();
  const { showMembershipFeatures } = useAuthState();

  const disabled = !showMembershipFeatures;

  const getCoordinatesButtonProps = (): LinkButtonProps | undefined => {
    if (disabled) {
      return {
        component: ReactRouterLink,
        to: {
          pathname: '/support_us/',
          search: `?plan=${MEMBERSHIP_PLANS.yearly}`,
          state: {
            fromRoute: window.location.pathname + window.location.search,
          },
        },
      };
    }
    return undefined;
  };

  return (
    <List
      subheader={
        <ListSubheader
          color="inherit"
          disableSticky
          sx={(theme) => ({
            padding: theme.spacing(3, 2, 2),
            lineHeight: 1,
            borderBottom: `1px solid ${theme.palette.divider}`,
          })}
        >
          <Stack direction="row" spacing={1}>
            <Typography variant="h3" sx={{ fontWeight: 'fontWeightBold' }}>
              {t('geoEvent.structuredInfo.initialLocation')}
            </Typography>
            <UserStatusChip type="members" />
          </Stack>
        </ListSubheader>
      }
    >
      <CoordinatesListItem
        coordinates={wildfire}
        format="decimal"
        buttonProps={getCoordinatesButtonProps()}
        blurred={disabled}
      />
      <CoordinatesListItem
        coordinates={wildfire}
        format="DDM"
        buttonProps={getCoordinatesButtonProps()}
        blurred={disabled}
      />
      <CoordinatesListItem
        coordinates={wildfire}
        format="DMS"
        buttonProps={getCoordinatesButtonProps()}
        blurred={disabled}
      />
    </List>
  );
};
